//
//
//
//
//
//
//
import echarts from 'echarts';
export default {
  props: ['chartData', 'lendName', 'total'],
  data: function data() {
    return {
      chart: null
    };
  },
  mounted: function mounted() {
    this.initChart();
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    chartData: {
      deep: true,
      handler: function handler(val) {
        this.setOptions(val);
      }
    }
  },
  methods: {
    setOptions: function setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c}({d}%)'
        },
        title: {
          itemGap: 0,
          text: '访问客户',
          subtext: this.total + '个',
          x: 'center',
          top: '55%',
          textAlign: 'center',
          left: '29%',
          textStyle: {
            fontSize: '16',
            fontWeight: 'bolder',
            color: ['#8C8C8C']
          },
          subtextStyle: {
            lineHeight: 46,
            rich: {
              a: {}
            },
            color: '#8C8C8C',
            fontSize: '16'
          }
        },
        legend: {
          orient: 'vertical',
          x: 'right',
          left: '60%',
          data: this.lendName,
          width: '50%',
          align: 'left',
          textStyle: {
            fontSize: 12,
            color: 'normal'
          },
          itemHeight: 10,
          itemWidth: 10,
          top: '20',
          selectedMode: false
        },
        series: [{
          type: 'pie',
          radius: ['35%', '70%'],
          center: ['60%', '60%'],
          color: ['#FFA500', '#FFF68F', '#FFDEAD', '#C71585', '#4169E1', '#3CB371'],
          textStyle: ['#FFA500', '#FFF68F', '#FFDEAD', '#C71585', '#4169E1', '#3CB371'],
          width: '50%',
          label: {
            normal: {
              formatter: '{per|{b}：{c}({d}%)}',
              rich: {
                per: {
                  width: '150%'
                }
              }
            }
          },
          labelLine: {
            normal: {
              length: 1
            }
          },
          data: [{
            value: this.chartData[0],
            name: this.lendName[0],
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    fontSize: '12'
                  },
                  show: true,
                  formatter: function formatter(params, option) {
                    if (params.data.value === 0) {
                      // params.data.itemStyle.normal.labelLine.show = false
                      params.data.label.normal.show = false;
                      params.data.labelLine.normal.show = false;
                    }
                  }
                },
                labelLine: {
                  show: true
                }
              }
            }
          }, {
            value: this.chartData[1],
            name: this.lendName[1],
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    fontSize: '12'
                  },
                  show: true,
                  formatter: function formatter(params, option) {
                    if (params.data.value === 0) {
                      // params.data.itemStyle.normal.labelLine.show = false
                      params.data.label.normal.show = false;
                      params.data.labelLine.normal.show = false;
                    }
                  }
                },
                labelLine: {
                  show: true
                }
              }
            }
          }, {
            value: this.chartData[2],
            name: this.lendName[2],
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    fontSize: '12'
                  },
                  show: true,
                  formatter: function formatter(params, option) {
                    if (params.data.value === 0) {
                      // params.data.itemStyle.normal.labelLine.show = false
                      params.data.label.normal.show = false;
                      params.data.labelLine.normal.show = false;
                    }
                  }
                },
                labelLine: {
                  show: true
                }
              }
            }
          }, {
            value: this.chartData[3],
            name: this.lendName[3],
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    fontSize: '12'
                  },
                  show: true,
                  formatter: function formatter(params, option) {
                    if (params.data.value === 0) {
                      // params.data.itemStyle.normal.labelLine.show = false
                      params.data.label.normal.show = false;
                      params.data.labelLine.normal.show = false;
                    }
                  }
                },
                labelLine: {
                  show: true
                }
              }
            }
          }, {
            value: this.chartData[4],
            name: this.lendName[4],
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    fontSize: '12'
                  },
                  show: true,
                  formatter: function formatter(params, option) {
                    if (params.data.value === 0) {
                      // params.data.itemStyle.normal.labelLine.show = false
                      params.data.label.normal.show = false;
                      params.data.labelLine.normal.show = false;
                    }
                  }
                },
                labelLine: {
                  show: true
                }
              }
            }
          }, {
            value: this.chartData[5],
            name: this.lendName[5],
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    fontSize: '12'
                  },
                  show: true,
                  formatter: function formatter(params, option) {
                    if (params.data.value === 0) {
                      // params.data.itemStyle.normal.labelLine.show = false
                      params.data.label.normal.show = false;
                      params.data.labelLine.normal.show = false;
                    }
                  }
                },
                labelLine: {
                  show: true
                }
              }
            }
          }]
        }]
      });
    },
    initChart: function initChart() {
      console.log(this.chartData);
      this.chart = echarts.init(this.$refs.statusEchart, 'macarons');
      this.setOptions(this.chartData);
    }
  }
};